import * as authHelper from './../../../../modules/auth/core/AuthHelpers'

import { FC } from "react"
import { IPageAction } from "../../../base/models"
import { MUIIcon } from "../../../widgets"
import { Property } from '../../../base/types'
import clsx from "clsx"
import { getBaseUrl } from '../url-helper'
import { useGetProperties } from '../../../base/hooks'

interface IActionUMSLinkProps {
    action: IPageAction
    className?: string
}

export const PortalLink: FC<IActionUMSLinkProps> = ({
    action, className
}) => {
    const { token } = authHelper.getAuth() || {}
    const { properties } = useGetProperties({ bindings: action.bindings });
    const pageUrl: string | undefined = properties[Property.Url];
    const target: string | undefined = properties[Property.Target];

    if (!token || !pageUrl)
        return <button
            type="button"
            className={className}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            {action.name}
        </button>

    const base64Token = btoa(token)
    return (
        <a
            className={clsx(className, "btn btn-secondary btn-sm")}
            target={target || undefined}
            href={`${getBaseUrl(pageUrl)}/auth/token-auth(${encodeURIComponent(base64Token)})`}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            <span>{action.name}</span>
        </a>
    )
}
